import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  errorSelector,
  setError,
} from '~/GlobalRedux/Features/error/errorSlice';
import { languageSelector } from '~/GlobalRedux/Features/language/languageSlice';

interface ErrorSnackbarProps {
  message?: string;
}

const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ message }) => {
  const dispatch = useDispatch();
  const isError = useSelector(errorSelector);

  const lang = useSelector(languageSelector);
  const text = {
    pt: 'Um erro aconteceu na requisição!',
    en: 'An error occurred in the request!',
    es: '¡Ocurrió un error en la solicitud!',
  };

  return (
    <>
      {isError && (
        <div className="fixed bottom-0 right-0 mb-8 mr-8 rounded-md bg-red-500 px-6 py-4 text-white">
          <p className="mb-2 text-xl font-bold">Oops!</p>
          <p>{message ?? text[lang]}</p>
          <button
            className="mt-2 rounded bg-white px-4 py-2 text-red-500"
            onClick={() => dispatch(setError(false))}
          >
            Fechar
          </button>
        </div>
      )}
    </>
  );
};

export default ErrorSnackbar;
